/* tslint:disable:jsx-no-lambda WI:47582 */
import * as React from 'react';
import { connect } from 'react-redux';
import {
    getGroupedPersonaListEntries,
    getGroupedSparsePersonaListEntries,
    getLoadingState,
    PersonaListEntry,
    SparsePersonaListEntries,
    getDisplayedItemHubPersonaIds,
} from '../../../selectors/personaListSelector';
import { extractSearchState } from '../../../utils/searchStateUtils';
import {
    getHideFilterFromOptionsDropDown,
    getHideOptionsDropDown,
    getIsFilterSelected,
    getOptionsText,
    getShowGroupsFromOptionsDropDown,
} from '../../../selectors/hubListHeaderSelector';
import {
    addFavoritePersonaClicked,
    removeFavoritePersonaClicked,
} from '../../../actions/user/favoritingUserActions';
import { getCurrentHubPersonaIds } from '../../../selectors/currentPersonaSelector';
import { getPersonaListHeaderTitle } from '../../../selectors/personaListHeaderTitleSelector';
import {
    allPersonasChecked,
    checkPersonaListItemToggled,
    mouseOverHubPersona,
    mouseLeaveHubPersona,
    personaListItemClicked,
    personaListItemFocus,
    personaListShiftItemClicked,
    PersonaClickedOrigin,
    personaListViewFilterChanged,
    personaListViewSortingChanged,
    personaListViewDisplayOrderChanged,
    checkedPersonasCleared,
    personaListScrollToGroupClicked,
    personaListVisibleEntriesChanged,
    personaListFetchSparseItem,
} from '../../../actions/user/personaListActions';
import { deletePersonasClicked } from '../../../actions/user/commandBarActions';
import {
    HubPersona,
    markPLTEvent,
    markPLTType,
    getLogger,
    FavoriteEntity,
    favoritesLeftNavItemId,
    ThunkDispatch,
    isConsumer,
    PersonaOperationStateType,
} from '../../../../shared';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    HubListWithHeader,
    HubListItem,
    SparseHubListItems,
    getCurrentQueryTerms,
    LoadingView,
} from '../../../../shared/components/hubList';
import { HubState, packageStateKey } from '../../../state';
import {
    getPackageState,
    isInSearchMode,
    Sorting,
    Filter,
    getActiveLeftNavItemId,
    getFavorites,
    isInEVNavigationMode,
    isActiveLeftNavItemDeletedItems,
    isSearchQueryPersonaPill,
    isInDeepLinkMode,
    sparseFolderTotalCount,
    getActiveLeftNavItemSparseFolder,
    updateShowHubListStatus,
    updateRightPaneStatus,
} from '../../../../appstate';
import { PersonaListLoadingState } from '../../../models/personaListLoadingState';
import EmptyViewAsync from './../emptyView/emptyViewAsync';
import EmptySearchViewAsync from './../emptySearchView/emptySearchViewAsync';
import SearchLoadingViewAsync from './../searchLoadingView/searchLoadingViewAsync';
import DeletedItemsHeaderAsync from './../deletedItemsHeader/deletedItemsHeaderAsync';
import ErrorViewAsync from '../errorView/errorViewAsync';
import { getPersonaListStatistics } from '../../../utils/personaListStatistics';
import { createHubListOptionsItems } from './personaListFilter';
import { createListFilterAriaLabel } from './personaListFilterAriaLabel';
import { getPersonaListEntries, getSparsePersonaListEntries } from './getPersonaListEntries';
import type { PersonaListViewModel } from '../../../models/PersonaListViewModel';
import { getPersonaListViewModel } from '../../../selectors/personaListViewModelSelector';
import {
    SearchResultType,
    searchResultTypeLabelClicked,
} from '../../../actions/user/resultTypeLabelActions';
import type { SearchResultViewModel } from '../personaItem/personaItem';
import { isCurrentHubPersonaInPublicFolder } from '../../../selectors/publicFolderSelector';
import { getDeleteOperationState } from '../../../selectors/currentPersonaOperationsSelectors';
import BulkActionProgressBarAsync from '../../bulkActionProgressBar/bulkActionProgressBarAsync';
import type DisplayOrder from 'owa-people-types/lib/types/DisplayOrder';
import { renderHubListContextMenu } from '../../hubListContextMenu/hubListContextMenuRenderer';
import { isCollapsedHublistOrRightPane } from '../../../utils/CollapsedHubListOrRightPaneStatus';
import { getBrowserWidthBucket } from 'owa-layout';

export type CheckPersonaListItemToggleType = (
    checkedPersonas: HubPersona[],
    uncheckedPersonas: HubPersona[],
    fetchMoreDetails: boolean
) => void;

export interface DataProps {
    readonly entries: PersonaListEntry[];
    readonly sparseEntries: SparsePersonaListEntries;
    readonly totalCount: number;
    readonly title: string;
    readonly isError: boolean;
    readonly isSearchMode: boolean;
    readonly isInCheckMode: boolean;
    readonly isInEVNavigationMode: boolean;
    readonly isLoading: boolean;
    readonly showGroupsFromDropDown: boolean;
    readonly currentHubPersonaIds: string[];
    readonly currentCheckedHubPersonaIds: string[];
    readonly hideOptionsDropDown: boolean;
    readonly hideFilterFromOptionsDropDown: boolean;
    readonly isInDeletedItems: boolean;
    readonly isInPublicFolder: boolean;
    readonly isInSparseFolder: boolean;
    readonly noFilterSelected: boolean;
    readonly optionsText: string;
    readonly areAllItemsChecked: boolean;
    readonly viewState: PersonaListViewModel;
    readonly searchResultViewModel: SearchResultViewModel;
    readonly favoritePersons: FavoriteEntity[];
    readonly displayedHubPersonaIds: string[];
    readonly activeLeftNavItemId: string;
    readonly clickedHubPersonaId: string;
    readonly isSearchWithPersonaPill: boolean;
    readonly isRecoverDeletedItemsEnabled: boolean;
    readonly moreItemsAreLoading: boolean;
    readonly allowDeletePersonas: boolean;
    readonly isInDeepLinkMode: boolean;
    readonly showRightPane: boolean;
    readonly showHubList: boolean;
}

export interface DispatchProps {
    onPersonaClick: (persona: HubPersona, origin: PersonaClickedOrigin) => void;
    onPersonaFocus: (persona: HubPersona) => void;
    onPersonaShiftClick: (persona: HubPersona, origin: PersonaClickedOrigin) => void;
    onCheckPersonaListItemToggle: CheckPersonaListItemToggleType;
    onAllPersonasChecked: (hubPersonaIds: string[]) => void;
    onCheckedPersonasClearedAction: () => void;
    onPersonaListScrollToGroupClicked: (firstItemInGroup: HubListItem) => void;
    onFilterChanged: (filter: Filter) => void;
    onSortingChanged: (sorting: Sorting) => void;
    onDisplayOrderChanged: (displayOrder: DisplayOrder) => void;
    onDeletePressed: () => void;
    onRemoveFilter: () => void;
    onSearchResultTypeLabelClicked: (resultType: SearchResultType) => void;
    onVisibleEntriesChanged: (entryIds: string[]) => void;
    onAddFavoritePersona: (persona: HubPersona) => void;
    onRemoveFavoritePersona: (persona: HubPersona) => void;
    onMouseOverHubPersona: (hubPersonaId: string) => void;
    onMouseLeaveHubPersona: () => void;
    onRenderSparseItem: (itemId: number) => void;
}

/**
 * Keeps track of activePersonaIds. Reason being
 */
function PersonaList(props: DataProps & DispatchProps) {
    // Using custom debounce, as this is more performant than using lodash.
    const onFocusTimeout = React.useRef(undefined);
    React.useEffect((): void => {
        if (!props.isLoading && props.entries.length) {
            markPLTEvent('PersonaListFirstReceivesData');
            markPLTType(
                'PeopleHubExperienceType',
                props.activeLeftNavItemId === favoritesLeftNavItemId ? 'Favorites' : 'Contacts'
            );

            if (props.entries.length) {
                const logger = getLogger();
                const stats = getPersonaListStatistics(
                    props.entries,
                    props.viewState.filter,
                    props.activeLeftNavItemId
                );
                logger.log(
                    'PersonaListStatistics',
                    props.hideOptionsDropDown
                        ? { folderId: stats.folderId, ...stats.counts }
                        : { folderId: stats.folderId, filter: stats.filter, ...stats.counts }
                );
            }
        }
    }, [props.entries, props.viewState.filter, props.activeLeftNavItemId]);

    const onFocusDebounceHandler = (func: Function) => {
        clearTimeout(onFocusTimeout.current);
        onFocusTimeout.current = setTimeout(func, 250);
    };

    const propsWithFocusHandler = {
        ...props,
        onFocusDebounceHandler: onFocusDebounceHandler,
    };
    const entries: HubListItem[] = getPersonaListEntries(propsWithFocusHandler);
    const sparseEntries: SparseHubListItems | undefined = getSparsePersonaListEntries(
        propsWithFocusHandler
    );
    let alternateView: JSX.Element = null;
    if (props.isLoading) {
        alternateView = props.isSearchMode ? (
            <SearchLoadingViewAsync />
        ) : (
            <LoadingView plain={props.isInSparseFolder} />
        );
    } else if (props.isError) {
        alternateView = <ErrorViewAsync />;
    } else if (!props.isLoading && !props.isError && props.entries.length === 0 && !sparseEntries) {
        alternateView = props.isSearchMode ? <EmptySearchViewAsync /> : <EmptyViewAsync />;
    }
    const shouldShowDeletedItemsHeader =
        props.isInDeletedItems && !isConsumer() && props.isRecoverDeletedItemsEnabled;
    return (
        <HubListWithHeader
            onFocusDebounceHandler={onFocusDebounceHandler}
            alternateView={alternateView}
            filterButtonAriaLabel={createListFilterAriaLabel(
                props.viewState,
                props.isSearchMode,
                props.hideFilterFromOptionsDropDown
            )}
            extraHeaderContent={
                <React.Fragment>
                    {shouldShowDeletedItemsHeader ? <DeletedItemsHeaderAsync /> : null}
                    {isFeatureEnabled('people-emptyFolder-bulk') && <BulkActionProgressBarAsync />}
                </React.Fragment>
            }
            hideCheckAll={
                props.isSearchMode ||
                props.isInDeepLinkMode ||
                props.isInEVNavigationMode ||
                props.isLoading ||
                props.isError ||
                props.activeLeftNavItemId === favoritesLeftNavItemId ||
                props.isInPublicFolder ||
                props.entries.length === 0
            }
            entries={entries}
            sparseEntries={sparseEntries}
            totalCount={props.totalCount}
            moreItemsAreLoading={props.moreItemsAreLoading}
            activeItemIds={props.currentHubPersonaIds}
            activeLeftNavItemId={props.activeLeftNavItemId}
            title={props.title}
            hideOptionsDropDown={props.hideOptionsDropDown}
            disableScrollToHubListGroupMenu={
                props.viewState.sorting === Sorting.ByRecentlyAdded ||
                props.viewState.sorting === Sorting.ByDeletedDate ||
                !!sparseEntries
            }
            areAllItemsChecked={props.areAllItemsChecked}
            onCheckAllItems={() => props.onAllPersonasChecked(props.displayedHubPersonaIds)}
            onClearAllItems={() => props.onCheckedPersonasClearedAction()}
            onScrollToGroupClicked={(firstItemInGroup: HubListItem) =>
                props.onPersonaListScrollToGroupClicked(firstItemInGroup)
            }
            currentOptionsText={props.optionsText}
            onDeletePressed={props.allowDeletePersonas && props.onDeletePressed}
            noFilterSelected={props.noFilterSelected}
            onRemoveFilter={props.onRemoveFilter}
            optionsDropDownItems={createHubListOptionsItems(
                props.viewState,
                props.isSearchMode,
                props.isInDeletedItems,
                props.hideFilterFromOptionsDropDown,
                props.showGroupsFromDropDown,
                props.onFilterChanged,
                props.onSortingChanged,
                props.onDisplayOrderChanged
            )}
            onVisibleEntriesChanged={entryIds => props.onVisibleEntriesChanged(entryIds)}
            onMouseOverHubPersona={props.onMouseOverHubPersona}
            onMouseLeaveHubPersona={props.onMouseLeaveHubPersona}
            onRenderSparseItem={itemId => props.onRenderSparseItem(itemId)}
            renderContextMenu={renderHubListContextMenu}
            showHubList={props.showHubList}
            showRightPane={props.showRightPane}
        />
    );
}
function mapStateToProps(rootState: any): DataProps {
    const state = getPackageState<HubState>(rootState, packageStateKey);

    const loadingState = getLoadingState(state.appState, state.packageState);
    const currentHubPersonaIds = getCurrentHubPersonaIds(state.appState, state.packageState);
    const checkedHubPersonaIds = state.appState.view.navigationState.personaListCheckedHubPersonaDetails.map(
        checkedHubPersonaDetails => checkedHubPersonaDetails.hubPersonaId
    );
    const displayedPersonaGroupedEntries = getGroupedPersonaListEntries(
        state.appState,
        state.packageState
    );
    const currentQuery = state.appState.view.navigationState.currentQuery;
    const displayedHubPersonaIds = getDisplayedItemHubPersonaIds(
        state.appState,
        state.packageState
    );
    const title = getPersonaListHeaderTitle(state.appState, state.packageState);
    const clickedHubPersonaId = state.appState.view.navigationState.clickedHubPersona
        ? state.appState.view.navigationState.clickedHubPersona.hubPersonaId
        : undefined;
    const isSearchWithPersonaPill = isSearchQueryPersonaPill(state.appState);
    const highlightTerms = getCurrentQueryTerms(currentQuery?.queryText);
    const activeLeftNavItemId = getActiveLeftNavItemId(state.appState);
    const isRecoverDeletedItemsEnabled =
        state.appState.data.userConfiguration.RecoverDeletedItemsEnabled;
    const { searchSuggestionsHasResults, searchStateHasResults } = extractSearchState(
        state.appState.data.searchState,
        currentQuery
    );
    const allowDeletePersonas =
        getDeleteOperationState(state.appState, state.packageState).type ===
        PersonaOperationStateType.Show;
    const sparseEntries = getGroupedSparsePersonaListEntries(state.appState);
    const totalCount = sparseFolderTotalCount(state.appState);

    return {
        entries: displayedPersonaGroupedEntries,
        sparseEntries,
        totalCount,
        moreItemsAreLoading: searchSuggestionsHasResults && !searchStateHasResults,
        isError: loadingState === PersonaListLoadingState.Error,
        isLoading: loadingState === PersonaListLoadingState.Loading,
        isInDeletedItems: isActiveLeftNavItemDeletedItems(state.appState),
        isInPublicFolder: isCurrentHubPersonaInPublicFolder(state.appState, state.packageState),
        isInSparseFolder: !!getActiveLeftNavItemSparseFolder(state.appState),
        currentCheckedHubPersonaIds: checkedHubPersonaIds,
        isSearchMode: isInSearchMode(state.appState),
        isInCheckMode: checkedHubPersonaIds && checkedHubPersonaIds.length > 0,
        areAllItemsChecked: displayedHubPersonaIds.length === checkedHubPersonaIds.length,
        viewState: getPersonaListViewModel(state.appState),
        searchResultViewModel: {
            highlightTerms,
            shouldShowTypeLabels:
                isFeatureEnabled('people-searchTypeLabels') &&
                highlightTerms &&
                !!highlightTerms.length,
            overrideTypeLabelFolderId: currentQuery?.folderId,
        },
        hideFilterFromOptionsDropDown: getHideFilterFromOptionsDropDown(state.appState),
        showGroupsFromDropDown: getShowGroupsFromOptionsDropDown(state.appState),
        hideOptionsDropDown: getHideOptionsDropDown(state.appState),
        noFilterSelected: getIsFilterSelected(state.appState),
        optionsText: getOptionsText(state.appState),
        favoritePersons: getFavorites(state.appState),
        isInEVNavigationMode: isInEVNavigationMode(state.appState),
        activeLeftNavItemId,
        clickedHubPersonaId,
        currentHubPersonaIds,
        displayedHubPersonaIds,
        isSearchWithPersonaPill,
        title,
        isRecoverDeletedItemsEnabled,
        allowDeletePersonas,
        isInDeepLinkMode: isInDeepLinkMode(state.appState),
        showRightPane: state.appState.view.layoutState.showRightPane,
        showHubList: state.appState.view.layoutState.showHubList,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onPersonaClick: (persona: HubPersona, origin: PersonaClickedOrigin) => {
            const inCollapsedHublistMode = isCollapsedHublistOrRightPane(getBrowserWidthBucket());
            if (inCollapsedHublistMode) {
                updateShowHubListStatus(dispatch)(false);
                updateRightPaneStatus(dispatch)(true);
                personaListItemClicked(dispatch)(persona, origin);
            } else {
                personaListItemClicked(dispatch)(persona, origin);
            }
        },
        onPersonaFocus: (persona: HubPersona) => personaListItemFocus(dispatch)(persona),
        onPersonaShiftClick: (persona: HubPersona, origin: PersonaClickedOrigin) =>
            personaListShiftItemClicked(dispatch)(persona, origin),
        onCheckPersonaListItemToggle: (
            checkedPersonas: HubPersona[],
            uncheckedPersonas: HubPersona[],
            fetchMoreDetails: boolean
        ) =>
            dispatch(checkPersonaListItemToggled)(
                checkedPersonas,
                uncheckedPersonas,
                fetchMoreDetails
            ),
        onAllPersonasChecked: (hubPersonaIds: string[]) =>
            allPersonasChecked(dispatch)(hubPersonaIds),
        onCheckedPersonasClearedAction: checkedPersonasCleared(dispatch),
        onFilterChanged: (filter: Filter) => dispatch(personaListViewFilterChanged)(filter),
        onSortingChanged: (sorting: Sorting) => dispatch(personaListViewSortingChanged)(sorting),
        onDisplayOrderChanged: (displayOrder: DisplayOrder) =>
            dispatch(personaListViewDisplayOrderChanged)(displayOrder),
        onPersonaListScrollToGroupClicked: (firstItemInGroup: HubListItem) =>
            personaListScrollToGroupClicked(dispatch)(firstItemInGroup.id),
        onDeletePressed: deletePersonasClicked(dispatch),
        onRemoveFilter: () => dispatch(personaListViewFilterChanged)(Filter.All),
        onSearchResultTypeLabelClicked: (resultType: SearchResultType) =>
            searchResultTypeLabelClicked(dispatch)(resultType),
        onVisibleEntriesChanged: (entryIds: string[]) =>
            dispatch(personaListVisibleEntriesChanged)(entryIds),
        onAddFavoritePersona: (persona: HubPersona) =>
            dispatch(addFavoritePersonaClicked(persona, 'hubList')),
        onRemoveFavoritePersona: (persona: HubPersona) =>
            dispatch(removeFavoritePersonaClicked(persona)),
        onMouseOverHubPersona: (hubPersonaId: string) =>
            mouseOverHubPersona(dispatch)(hubPersonaId),
        onMouseLeaveHubPersona: () => mouseLeaveHubPersona(dispatch)(),
        onRenderSparseItem: (itemId: number) => dispatch(personaListFetchSparseItem)(itemId),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonaList);
